import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: process.env.NODE_ENV === 'production' ? 'https://api.madispo.com' : 'http://localhost:3000',
  headers: {
    'Content-Type': 'application/json'
  },
  withCredentials: true,
});

export default axiosInstance;